import initPhotoSwipe from '../lib/photoswipe';

export default {
  init() {
    initPhotoSwipe('.gallery');
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/fotogaleria.js